export const TokenVerificationScenario = {
  AIV: 1,
  FCA: 2,
  CN: 3,
};

// China qualification type
export const CNQualificationType = {
  Industry: 0,
  Supplementary: 1,
};

// China qualification verification status
export const CNQualificationStatus = {
  Failed: 71,
  ActionRequired: 72,
  NotVerified: 73,
  Pending: 74,
  Verified: 75,
  LicenseExpired: 76,
};
